import styled from 'styled-components'
import { useSettings } from "../../contexts/SettingsProvider";
import { Columns } from '../../styles/functions';
import { TypeBodyM } from '../../styles/mixins';
import GlobalSlideshow from '../global/GlobalSlideshow';
import SanityRegenerationCard from './SanityRegenerationCard';

interface Props {
  className?: string
}
const SanityRegeneration: React.FC<Props> = ({ 
  className,
}: Props) => {
  const {regeneration} = useSettings();
  const slideshowSettings = {
    dragFree: true,
    containScroll: 'keepSnaps',
    // align: 'start',
  }

  return (
    <Container className={className}>
      <GlobalSlideshow settings={slideshowSettings}>
        { regeneration.cards.map((card) => (
            <CardWrap key={card._key}>
              <Card card={card}  />
            </CardWrap>
          ))
        }
      </GlobalSlideshow>
    </Container>
  )
}

const Container = styled.div`
  /* display: flex; */
  /* grid-gap: var(--gutter); */
`

const CardWrap = styled.div`
  padding-left: var(--gutter);
  counter-increment: cardNumber;
  &:nth-child(1) {
    padding-left: var(--inset);
  }
  &:last-child {
    padding-right: var(--inset);
  }
`

const Card = styled(SanityRegenerationCard)`
  width: ${Columns(11)};
  flex-shrink: 0;
  position: relative;

  &:after {
    ${TypeBodyM};
    content: counter( cardNumber , decimal-leading-zero) '.';
    top: var(--spacing-24);
    left: 24px;
    color: var(--color-background);
    position: absolute;
  }
`

export default SanityRegeneration